import { t } from 'i18next'

import { OperationConfirmationState } from '../../../../common/validations'
import { ContractType } from '../../../../common/types'
import { resolveContractTerminationTerminology } from './resolveContractTerminationTerminology'

export const resolveOperationConfirmationStateText = (
  state: OperationConfirmationState,
  contractType: ContractType
) => {
  const { confirmationState } =
    resolveContractTerminationTerminology(contractType)

  switch (state) {
    case OperationConfirmationState.CONFIRMED:
      return t(confirmationState.confirmed)
    case OperationConfirmationState.PENDING:
      return t(confirmationState.pending)
    case OperationConfirmationState.REJECTED:
      return t(confirmationState.rejected)
    default:
      return t(confirmationState.notFound)
  }
}

export const resolveModificationOperationConfirmationStateText = (
  state: OperationConfirmationState
) => {
  switch (state) {
    case OperationConfirmationState.CONFIRMED:
      return t('contractModification:confirmationState.modificationConfirmed')
    case OperationConfirmationState.PENDING:
      return t('contractModification:confirmationState.modificationPending')
    case OperationConfirmationState.REJECTED:
      return t('contractModification:confirmationState.modificationRejected')
    default:
      return t('contractModification:confirmationState.modificationNotFound')
  }
}
